import { computed } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';

/**
 * SiteUp: Kanban accordion in Contatos must react to account id / feature
 * flags becoming available after first paint. A one-shot setup() read stays
 * false forever when the account bootstrap is still warming.
 */
export function useKanbanBoardEnabled() {
  const currentAccountId = useMapGetter('getCurrentAccountId');
  const isFeatureEnabledonAccount = useMapGetter(
    'accounts/isFeatureEnabledonAccount'
  );

  return computed(() => {
    const check = isFeatureEnabledonAccount.value;
    if (typeof check !== 'function' || !currentAccountId.value) return false;
    return !!check(currentAccountId.value, FEATURE_FLAGS.KANBAN_BOARD);
  });
}
